export const texts = {
  title: {
    de: 'Screening-Fragen',
    en: 'Screening questions'
  }
};
